// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";

import { Button, Loading } from "../../atoms";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { downloadExcel } from "../../../util/downloadExcel";
import {
    useGetMerchantsWithParentMerchant,
    useGetMerchantFinancialReport,
    useGetMerchantFinancialReportExternal
} from "../../../hooks";

import {
    FormControl,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    Table,
} from "../../molecules";

export const MerchantFinancialDocumentsGenerator = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const [isPageLoading, setIsPageLoading] = useState(true);

    const forms = useForm();

    const { data: rawMerchantList, isLoading: isMerchantLoading } = useGetMerchantsWithParentMerchant();
    const { mutate: getMerchantFinancialDocument, isLoading: isMerchantCommissionsLoading } = useGetMerchantFinancialReport();
    const { mutate: getMerchantFinancialDocumentExternal, isLoading: isMerchantDocumentRequestExternalLoading } = useGetMerchantFinancialReportExternal();

    const merchantList = useMemo(() => {
        setIsPageLoading(false);
        return rawMerchantList?.data?.map((item: { merchantName: string, merchantId: number }) => {
            return {
                label: "( " + item.taxNumber + " ) " + item.merchantName + ` (${item.merchantId})`,
                value: item.merchantId
            }
        });
    }, [rawMerchantList?.data]);

    const isLoading = false;

    const [selectedMerchant, setSelectedMerchant] = useState<{ label: string, value: number } | null>(null);
    const [selectedFormType, setSelectedFormType] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);

    const [isFinancialDocumentLoading, setIsFinancialDocumentLoading] = useState(false);

    const GenerateFinancialDocument = () => {

        if (selectedMerchant == null) {
        }

        setIsFinancialDocumentLoading(true);

        if (selectedFormType == 1) {
            // Dekont
            let req = {
                merchantId: selectedMerchant?.value?.toString(),
                posType: 1,
                year: selectedYear.toString(),
                month: selectedMonth.toString()
            };

            getMerchantFinancialDocumentExternal(req, {
                onSuccess: (result) => {
                    setIsFinancialDocumentLoading(false);
                    let blob = base64ToBlob(result.result.data);
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                },
                onError: (result) => {
                    setIsFinancialDocumentLoading(false);
                }
            })
        } else if (selectedFormType == 2) {
            let req = {
                merchantId: selectedMerchant?.value,
                year: selectedYear,
                month: selectedMonth
            };

            getMerchantFinancialDocument(req, {
                onSuccess: (result) => {
                    let blob = base64ToBlob(result.data);
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    setIsFinancialDocumentLoading(false);
                },
                onError: (result) => {
                    setIsFinancialDocumentLoading(false);
                }
            })
        }
    }

    const base64ToBlob = (base64Data) => {
        const base64WithoutPrefix = base64Data.replace('data:application/pdf;base64,', '');

        const bytes = atob(base64WithoutPrefix);

        const uint8Array = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            uint8Array[i] = bytes.charCodeAt(i);
        }

        return new Blob([uint8Array], { type: 'application/pdf' });
    };

    const monthList = [
        {
            key: 1,
            value: 'Ocak'
        },
        {
            key: 2,
            value: 'Şubat'
        },
        {
            key: 3,
            value: 'Mart'
        },
        {
            key: 4,
            value: 'Nisan'
        },
        {
            key: 5,
            value: 'Mayıs'
        },
        {
            key: 6,
            value: 'Haziran'
        },
        {
            key: 7,
            value: 'Temmuz'
        },
        {
            key: 8,
            value: 'Ağustos'
        },
        {
            key: 9,
            value: 'Eylül'
        },
        {
            key: 10,
            value: 'Ekim'
        },
        {
            key: 11,
            value: 'Kasım'
        },
        {
            key: 12,
            value: 'Aralık'
        }
    ];

    const formTypes = [
        {
            key: 1,
            value: 'Dekont'
        },
        {
            key: 2,
            value: 'Ekstre'
        }
    ]

    const yearList = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2000;
        const years = [];

        for (let year = startYear; year <= currentYear; year++) {
            years.push({
                key: year,
                label: year.toString()
            });
        }

        return years;
    }, []);

    return (
        <>
            {isPageLoading && <Loading />}
            <Stack flex={1} justifyContent={'space-between'}>
                <Stack flex={1} p={2}>
                    <Stack spacing={4}>
                        <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} width={isDesktop ? '100%' : 'auto'}>
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        control={forms.control}
                                        name="merchantId"
                                        render={({ field, fieldState }) => {
                                            return (
                                                <Autocomplete
                                                    sx={{ mr: isDesktop ? 2 : 0 }}
                                                    onChange={(event, selectedValue) => {
                                                        setSelectedMerchant(selectedValue);
                                                        field.onChange(selectedValue?.value || 0);
                                                    }}
                                                    id="merchantId"
                                                    options={merchantList}
                                                    // defaultValue={user?.id ? selectedMerchant : null}
                                                    getOptionLabel={(option: {
                                                        label: string;
                                                        value: number;
                                                    }) => option.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Üye İşyeri"
                                                            error={fieldState.invalid}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            );
                                        }}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                <Controller
                                    control={forms.control}
                                    name="formType"
                                    render={({ field, fieldState }) => {
                                        return (
                                            <Autocomplete
                                                sx={{ mr: isDesktop ? 2 : 0 }}
                                                onChange={(event, selectedValue) => {
                                                    setSelectedFormType(selectedValue?.key);
                                                    field.onChange(selectedValue?.value || 0);
                                                }}
                                                id="formType"
                                                options={formTypes}
                                                getOptionLabel={(option: {
                                                    key: number;
                                                    value: string;
                                                }) => option.value}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="İşlem Tipi"
                                                        error={fieldState.invalid}
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            </FormControl>
                        </Stack>
                        <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} width={isDesktop ? '100%' : 'auto'}>
                            <FormControl sx={{ flex: 1 }}>
                                <Controller
                                    control={forms.control}
                                    name="merchantId"
                                    render={({ field, fieldState }) => {
                                        return (
                                            <Autocomplete
                                                sx={{ mr: isDesktop ? 2 : 0 }}
                                                onChange={(event, selectedValue) => {
                                                    setSelectedYear(selectedValue?.key);
                                                    field.onChange(selectedValue?.value || 0);
                                                }}
                                                id="merchantId"
                                                options={yearList}
                                                getOptionLabel={(option: {
                                                    key: string;
                                                    value: number;
                                                }) => option.key}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Yıl"
                                                        error={fieldState.invalid}
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                <Controller
                                    control={forms.control}
                                    name="month"
                                    render={({ field, fieldState }) => {
                                        return (
                                            <Autocomplete
                                                sx={{ mr: isDesktop ? 2 : 0 }}
                                                onChange={(event, selectedValue) => {
                                                    setSelectedMonth(selectedValue?.key);
                                                    field.onChange(selectedValue?.value || 0);
                                                }}
                                                id="month"
                                                options={monthList}
                                                getOptionLabel={(option: {
                                                    key: string;
                                                    value: number;
                                                }) => `${option.key} ${option.value}`}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Ay"
                                                        error={fieldState.invalid}
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            </FormControl>
                        </Stack>
                        <Stack>
                            <Button
                                onClick={GenerateFinancialDocument}
                                variant="contained"
                                text={"Oluştur"}
                                disabled={isFinancialDocumentLoading}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}